// Imports
import {
  registerCallback as registerEventCallback,
} from '../Events';

/**
 * Current window width.
 * @type {Number}
 */
let windowWidth = 0;

/**
 * Current window height.
 * @type {Number}
 */
let windowHeight = 0;

/**
 * Array used to store callbacks for the window resize event.
 * @type {Array}
*/
const windowResizeCallbacks = [];

/**
 * Registers a callback for the window "resize" event.
 * @param  {Function} aoCallback            - The callback function.
 * @param  {Boolean}  abOnOrientationChange - Whether or not the orientation must have changed
 * for the callback to be called.
 */
function registerWindowResizeCallback(aoCallback, abOnOrientationChange) {
  windowResizeCallbacks.push({
    callback: aoCallback,
    onOrientationChange: abOnOrientationChange,
  });
}

function onWindowResize(aoEvent) {
  // Check window width has actually changed and it's not just iOS
  // triggering a resize event on scroll
  const orientationChanged = $(window).width() !== windowWidth;

  // Update the window width for next time
  windowWidth = $(window).width();

  // Update the window height for next time
  windowHeight = $(window).height();

  setTimeout(() => {
    // Call the callbacks
    for (let i = 0; i < windowResizeCallbacks.length; i += 1) {
      const callbackData = windowResizeCallbacks[i];

      // Check orientation change constraint
      if (orientationChanged || !callbackData.onOrientationChange) {
        callbackData.callback.call(window, aoEvent);
      }
    }
  }, 0);
}

function handleWindowResize() {
  registerEventCallback({
    events: 'resize',
    handler: onWindowResize,
    target: window,
  });
}

function getWindowWidth() {
  return windowWidth;
}

function getWindowHeight() {
  return windowHeight;
}

function init() {
  // Save window width
  windowWidth = $(window).width();

  // Save window width
  windowHeight = $(window).height();

  // Handle window resize
  handleWindowResize();
}

// Named exports - Functions
export {
  init,
  registerWindowResizeCallback,
  getWindowWidth,
  getWindowHeight,
};



// WEBPACK FOOTER //
// ./js/common/tools/WindowResizeHandler.js